import Tooltip from '@atlaskit/tooltip';
import React from 'react';
import { reasonKeyToContent } from "./FeedbackReports.constants";
export const headerConfigByFilter = {
  newReasons: ['appFunctionality', 'expensive', 'alternative', 'customerSupport', 'expectations', 'appDesign', 'migrate', 'other'],
  adminHub: ['merging', 'covid', 'sandbox', 'competitor', 'skipped', 'moving-to-server-or-dc', 'org-change', 'product-experience', 'resetting', 'post-evaluation', 'other'],
  manageApps: ['bugs', 'cost', 'functionality', 'interface', 'restarting', 'usefulness', 'other'],
  type: ['unsubscribe', 'uninstall', 'disable']
};
export const FeedbackHeaderContent = ({
  reason
}) => reason.tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
  content: reason.tooltip
}, /*#__PURE__*/React.createElement("span", null, reason.name)) : reason.name;
export const getAppsWidth = reportBy => reportBy === 'reason' ? 20 : 30;
export const getFeedbacksReportHeader = (reportBy, source) => {
  const headerConfig = headerConfigByFilter[reportBy] || headerConfigByFilter[source];
  const allAppsWidth = getAppsWidth(reportBy);
  const style = {
    width: "".concat((100 - allAppsWidth) / (headerConfig.length + 1), "%")
  };
  return {
    cells: [{
      key: 'appKey',
      content: 'App',
      isSortable: true,
      style: {
        width: "".concat(allAppsWidth, "%")
      }
    }, ...headerConfig.map(reasonKey => ({
      key: reasonKey,
      content: /*#__PURE__*/React.createElement(FeedbackHeaderContent, {
        reason: reasonKeyToContent[reasonKey]
      }),
      isSortable: true,
      style
    })), {
      key: 'total',
      content: 'Total',
      isSortable: true,
      style
    }]
  };
};